export enum Constants {}

export enum FormEvents {
  SH_CONFIGURATION_FORM = "nf_configuration_form",
  SH_SONG_FORM = "nf_song_form",
  SH_CAMPAIGN_FORM = "nf_campaign_form",
  SH_CAMPAIGN = "nf_campaign",
  SH_DISABLE_USER = "nf_disable_user",
  SH_AD_FORM = "nf_ad_form",
  SH_SEND_EMAIL = "nf_send_email"
}
